import { METRIC_NAME } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import { v4 as uuidv4 } from 'uuid';

let riskifiedDeviceId = '';
export async function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['riskified']) {
    const { url } = data
    riskifiedDeviceId = uuidv4();
    window.__riskifiedDeviceId = riskifiedDeviceId
    loadScript(`${url}&sid=${riskifiedDeviceId}`);
}

const loadScript = (url: string) => {
    const time = Date.now()
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    }).then(() => {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { url, type: 'loadRiskified' },
            value: Date.now() - time,
            message: 'riskified load success',
        })
    }).then(() => {
        monitorSingleJsLoadTime(riskifiedDeviceId, 'beacon.riskified.com', 'riskified');
    })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadRiskifiedError' },
                value: Date.now() - time,
                message: 'riskified load error',
                params: error
            })
        })
}
export function provideRiskifiedDeviceId() {
    return riskifiedDeviceId || ''
}